import { lazy } from 'react';

// Lazy-loaded components
export const LazyComponents = {
  HeaderBanner: lazy(() =>
    import('../components/HeaderBanner').then((m) => ({
      default: m.HeaderBanner,
    })),
  ),
  PromotionalMessage: lazy(() =>
    import('../components/HeaderBanner/PromotionalMessage').then((m) => ({
      default: m.PromotionalMessage,
    })),
  ),
  SaleBanner: lazy(() =>
    import('../components/SaleBanner').then((m) => ({ default: m.SaleBanner })),
  ),
  ProductCards: lazy(() =>
    import('../components/ProductCards').then((m) => ({
      default: m.ProductCards,
    })),
  ),
  EnterpriseBanner: lazy(() =>
    import('../components/EnterpriseBanner').then((m) => ({
      default: m.EnterpriseBanner,
    })),
  ),
  FeaturesGrid: lazy(() =>
    import('../components/FeaturesGrid').then((m) => ({
      default: m.FeaturesGrid,
    })),
  ),
  PlansSection: lazy(() =>
    import('../components/PlansSection').then((m) => ({
      default: m.PlansSection,
    })),
  ),
  CycleSection: lazy(() =>
    import('../components/CycleSection').then((m) => ({
      default: m.CycleSection,
    })),
  ),
  Faq: lazy(() =>
    import('@wix/package-picker-shared-eclipse').then((m) => ({
      default: m.Faq,
    })),
  ),
  PageFooter: lazy(() =>
    import('@wix/package-picker-shared-eclipse').then((m) => ({
      default: m.PageFooter,
    })),
  ),
};

// Lazy-loaded pages
export const LazyPages = {
  SelectPlanPage: lazy(() =>
    import('../pages/SelectPlanPage/SelectPlanPage').then((m) => ({
      default: m.SelectPlanPage,
    })),
  ),
  SelectCyclePage: lazy(() =>
    import('../pages/SelectCyclePage/SelectCyclePage').then((m) => ({
      default: m.SelectCyclePage,
    })),
  ),
  CheckoutPage: lazy(() =>
    import('../pages/CheckoutPage/CheckoutPage').then((m) => ({
      default: m.CheckoutPage,
    })),
  ),
};
